import React from 'react';
import HeaderTitle from 'header/components/title';

const AccountHeaderTitle = () => (
  <HeaderTitle title="Your Account" />
);

export default AccountHeaderTitle;
